<template>
  <div>

    <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.formLinkable)">
      <panel-item id="pn-linked-form">
        <label :for="selectedObjectModelTrigger.idForProp('linked_form_id')" class="a-select-label">Generate Which
          Form?</label>
        <a-select
          v-model="linkedForm"
          bind-by-object
          :options="linkedFormVSelectOptions"
          compress
          :id="selectedObjectModelTrigger.idForProp('linked_form_id')"
          placeholder="Search forms..."></a-select>
      </panel-item>
    </panel-block>
    <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.runMappable)">
      <panel-item id="ot-linked-mapping">
        <label :for="selectedObjectModelTrigger.idForProp('mapping_id')" class="a-select-label">
          Run which mapping?</label>
        <a-select :options="orgMappingsOptions"
                  :id="selectedObjectModelTrigger.idForProp('mapping_id')"
                  :key="selectedObjectModelTrigger.mapping_id ? selectedObjectModelTrigger.mapping_id: 'select-mapping'"
                  bind-by-object
                  compress
                  v-model="linkedMapping"></a-select>
      </panel-item>
    </panel-block>

    <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.runProcessable)">
      <panel-item id="ot-linked-process">
        <label :for="selectedObjectModelTrigger.idForProp('process_flow_id')" class="a-select-label">
          Run which process flow?</label>
        <a-select :options="orgProcessFlowOptions"
                  :id="selectedObjectModelTrigger.idForProp('process_flow_id')"
                  :key="selectedObjectModelTrigger.process_flow_id ? selectedProcessFlow.id: 'select-process-flow'"
                  bind-by-object
                  compress
                  v-model="selectedProcessFlow"></a-select>
        <button v-if="selectedObjectModelTrigger.process_flow_id"
                id="configure-process-flow"
                class="btn grey-to-blue full-sz"
                @click="showProcessModal">
          Configure
        </button>
        <view-configure-process-flow-modal
          @toggle-modal="hideModal(vueModalID.configureObjectModelProcessFlow)"
          v-if="modalStateFor(vueModalID.configureObjectModelProcessFlow).isVisible"
          :state="modalStateFor(vueModalID.configureObjectModelProcessFlow)"
          :index="vueModalID.configureObjectModelProcessFlow"
          :parentModel="selectedObjectModelTrigger"
          :object-model="selectedObjectModel"
          :process-flow="selectedProcessFlow">
        </view-configure-process-flow-modal>
      </panel-item>
    </panel-block>

    <template v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.propertyUpdateable)">
      <template
        v-for="(propertyUpdate,  index) in selectedObjectModelTrigger.propertyUpdatesArray"
      >
        <panel-block :key="`update_value_${propertyUpdate.property_client_id}`">
          <configure-property-update
            :deleteable="index !== 0"
            :key="propertyUpdate.property_client_id"
            :property-update="propertyUpdate"
            :property-options="updateableProperties"
            v-on:remove="removePropertyUpdate(propertyUpdate)"
          >
            <template v-if="propertyUpdate.property_client_id">
              <component
                v-if="isPickList(propertyUpdate.property_client_id)"
                :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
                :disabled="propertyUpdate.clear_value"
                :id="`update_value_${propertyUpdate.property_client_id}`"
                class="mb-0"
                :property-client-id="propertyUpdate.property_client_id"
                :object-model="selectedObjectModel"
                v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
                v-model="propertyUpdate.values_to_update_to_array"
              ></component>
              <formula-wrapper
                v-else-if="isDateTime(propertyUpdate.property_client_id)"
                field-name="value_to_update_to"
                :parent="propertyUpdate"
                :dynamic-options="updatePropertyValueDateFormulaDynamicOptions"
                serverside-warning-tooltip
              >
                <template #value>
                  <component
                    :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
                    :id="`update_value_${propertyUpdate.property_client_id}`"
                    class="mb-0"
                    :property-client-id="propertyUpdate.property_client_id"
                    :object-model="selectedObjectModel"
                    v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
                    v-model="propertyUpdate.value_to_update_to"
                    :disabled="propertyUpdate.clear_value"
                  ></component>
                </template>
              </formula-wrapper>
              <component
                v-else
                :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
                :disabled="propertyUpdate.clear_value"
                :isDisabled="propertyUpdate.clear_value"
                :id="`update_value_${propertyUpdate.property_client_id}`"
                class="mb-0"
                :property-client-id="propertyUpdate.property_client_id"
                :object-model="selectedObjectModel"
                v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
                v-model="propertyUpdate.value_to_update_to"
              ></component>
            </template>
          </configure-property-update>
        </panel-block>
      </template>
      <panel-block>
        <panel-actions>
          <button @click="addPropertyUpdate" type="button" class="btn grey-to-blue full-sz" id="add-notification">
            Add Property to Update
          </button>
        </panel-actions>
      </panel-block>
    </template>
    <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.relatedObjectPropertyUpdatable)">
      <panel-item>

        <label :for="selectedObjectModelTrigger.idForProp('linked_relationship_client_id')" class="a-select-label">
          Update Which Relationship?</label>
        <a-select :options="linkedRelationshipSearchOptions"
                  compress
                  force-nullify-if-null
                  bind-by-object
                  :id="selectedObjectModelTrigger.idForProp('linked_relationship_client_id')"
                  :key="selectedObjectModelTrigger.linked_relationship_client_id ? selectedObjectModelTrigger.linked_relationship_client_id: 'select-relationship'"
                  :value="getRelationOption()"
                  @input="setRelationOption"
                  ></a-select>
      </panel-item>
      <panel-item v-if="!!selectedObjectModelTrigger.linked_relationship_client_id">

        <div v-for="relatedModelUpdate in selectedObjectModelTrigger.relatedModelUpdatesArray">
          <panel-block>
            <configure-related-model-update :related-model-update="relatedModelUpdate"
                                            :linkable-models="linkedObjectModels">

            </configure-related-model-update>
          </panel-block>
        </div>
        <panel-actions>
          <button @click="addRelatedModelUpdate" type="button" class="btn grey-to-blue full-sz"
                  id="add-related-model-update">
            Add Another Model to Update
          </button>
        </panel-actions>

      </panel-item>

    </panel-block>

    <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.removeRelationshipable)">
      <panel-item>

        <label :for="selectedObjectModelTrigger.idForProp('relationship_id')" class="a-select-label">
          Remove which relationship?</label>
        <a-select :options="relationshipSearchOptions"
                  :id="selectedObjectModelTrigger.idForProp('relationship_id')"
                  :key="selectedObjectModelTrigger.relationship_id ? selectedObjectModelTrigger.relationship_id: 'select-relationship'"
                  compress
                  force-nullify-if-null
                  bind-by-object
                  :value="getRemoveOrEstablishRelationOption()"
                  @input="setRemoveOrEstablishRelationOption"
                  ></a-select>
      </panel-item>
    </panel-block>

    <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.establishRelationshipable)">
      <panel-item>

        <label :for="selectedObjectModelTrigger.idForProp('foreign_key')" class="a-select-label">
          Foreign Key?</label>
        <a-select
          :options="foreignKeyOptions"
          :id="selectedObjectModelTrigger.idForProp('foreign_key')"
          compress
          force-nullify-if-null
          v-model="selectedObjectModelTrigger.foreign_key"
        ></a-select>


        <label :for="selectedObjectModelTrigger.idForProp('relationship_id')" class="a-select-label">
          Establish which relationship?</label>
        <a-select :options="relationshipSearchOptions"
                  :id="selectedObjectModelTrigger.idForProp('relationship_id')"
                  :key="selectedObjectModelTrigger.relationship_id ? selectedObjectModelTrigger.relationship_id: 'select-relationship'"
                  compress
                  force-nullify-if-null
                  bind-by-object
                  :value="getRemoveOrEstablishRelationOption()"
                  @input="setRemoveOrEstablishRelationOption"
                  ></a-select>

        <template v-for="linkedModel in linkedObjectModels">
          <template>
            <label :for="linkedModel.client_id" class="a-select-label">
              {{ `${linkedModel.title}'s Primary Key` }}</label>
            <a-select :options="objectModelPropertyOptions(linkedModel)"
                      :id="linkedModel.client_id"
                      compress
                      force-nullify-if-null
                      bind-by-object
                      :value="getPrimaryKey(linkedModel)"
                      @input="setPrimaryKey(linkedModel, $event)"
            ></a-select>
          </template>
        </template>
      </panel-item>
    </panel-block>

    <panel-block>
      <panel-item>
        <panel-title>Notification</panel-title>

        <configure-notification
          :parent="selectedObjectModelTrigger"
          :dynamic-fields-handler="dynamicFieldsHandler"
          :notification-factory="ObjectModelTriggerNotificationFactory"
          :permittee-options="notificationPermiteeOptions"></configure-notification>
      </panel-item>
    </panel-block>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {ObjectModelActionCapability} from "~/models/objectModelActions/objectModelActionCapability";
  import selectedMixin from "../mixins/selectedMixin";
  import {ObjectModelTriggerBasedOnType} from "~/enums/objectModelTriggerBasedOnType";
  import {ObjectModelTriggerCapability} from "~/models/objectModelTriggers/objectModelTriggerCapability";
  import ConfigureNotification from "~/components/configuration/configure-notifications.vue"
  import appGroupPermitteeSearchMixin from "~/mixins/appGroupPermitteeSearchMixin";  
  import ObjectModelPropertyDynamicFieldsHandler from "~/models/dynamicFields/handlers/objectModelPropertyDynamicFieldsHandler";
  import ObjectModelTriggerNotificationFactory from '~/models/objectModels/objectModelTriggerNotificationFactory';
  import {IVOptionSetEndpoint, IVOptionSetLocal} from "~/interfaces/vSelectInterfaces";
  import objectModelEntryInputFieldMixin from "~/mixins/objectModelEntries/objectModelEntryInputFieldMixin";
  import propertyUpdateMixin from "../mixins/propertyUpdateMixin";
  import ObjectModel from "~/models/objectModel";
  import {ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
  import ConfigureRelatedModelUpdate from "./configure-related-model-update.vue";
  import ViewConfigureProcessFlowModal from "./view-configure-process-flow-modal.vue";
  import ConfigurePropertyUpdate from "~/components/configuration/configure-property-update.vue";
  import FormulaWrapper from "~/components/formulas/formulaWrapper.vue";
  import {IDynamicFieldsOptions} from "~/interfaces/dynamicFieldsInterfaces/dynamicOptionsInterfaces";
  import RelatedModelPrimaryKey from "~/models/relatedModelPrimaryKey";
  import {PickListSelectionType} from "~/enums/pickListSelectionType";
  import ProcessFlowSubmissionMappedVariable from "~/models/processFlows/processFlowSubmissionMappedVariable";
  import {IShallowProcessFlow} from "~/interfaces/processFlowInterfaces";
  import {RouteHelper} from "~/helpers/routeHelper";
  import {Route} from "~/enums/route";

  export default Vue.extend({
    mixins: [
      selectedMixin,
      appGroupPermitteeSearchMixin,
      objectModelEntryInputFieldMixin,
      propertyUpdateMixin
    ],
    components: {
      ConfigureNotification,
      ConfigureRelatedModelUpdate,
      ConfigurePropertyUpdate,
      FormulaWrapper,
      ViewConfigureProcessFlowModal,
    },
    data: function () {
      return {
        ObjectModelActionCapability,
        ObjectModelTriggerBasedOnType,
        editedConfirmation: null,
        ObjectModelTriggerCapability,
        ObjectModelTriggerNotificationFactory,
        notificationPermiteeOptions: []
      };
    },
    methods:{
      addPropertyUpdate(): void {
        this.selectedObjectModelTrigger.appendPropertyUpdate()
      },
      addRelatedModelUpdate(): void {
        this.selectedObjectModelTrigger.appendRelatedModelUpdate()
      },
      setRelationOption(relation) {
        this.selectedObjectModelTrigger.inverse = relation.inverse
        this.selectedObjectModelTrigger.linked_relationship_client_id = relation.client_id
      },
      getRelationOption() {
        const relation = this.selectedObjectModel.allRelations.find(r => r.client_id === this.selectedObjectModelTrigger.linked_relationship_client_id && r.inverse === this.selectedObjectModelTrigger.inverse)
        if (!relation) return null
        return relation.client_id_inverse
      },
      setRemoveOrEstablishRelationOption(relation) {
        this.selectedObjectModelTrigger.inverse = relation.inverse;
        this.selectedObjectModelTrigger.relationship_id = relation.id;
        this.selectedObjectModelTrigger.linked_relationship_client_id = relation.client_id;
      },
      getRemoveOrEstablishRelationOption() {
        const relation = this.selectedObjectModel.allRelations.find(r => r.id === this.selectedObjectModelTrigger.relationship_id && r.inverse === this.selectedObjectModelTrigger.inverse)
        if (!relation) return null
        return relation.client_id_inverse
      },
      objectModelPropertyOptions(objectModel) {
        const options = objectModel.objectModelPropertiesArray.filter(omp => omp.property_type !== ObjectModelPropertyRootType.PickList || omp.selection_type !== PickListSelectionType.MultiSelect);
        return {
          valueKey: "client_id",
          labelKey: "labelTitleDisplay",
          options: options,
          heading: ""
        };
      },
      getPrimaryKey(objectModel) {
        let primaryKey = this.selectedObjectModelTrigger.relatedModelPrimaryKeysArray.find(key => key.related_model_id === objectModel.id);
        if (!primaryKey) {
          primaryKey = new RelatedModelPrimaryKey(this.selectedObjectModelTrigger, 'related_model_primary_keys', {});
          primaryKey.related_model_id = objectModel.id;
          this.selectedObjectModelTrigger.related_model_primary_keys[primaryKey.client_id] = primaryKey;
        }
        return primaryKey.primary_key;
      },
      setPrimaryKey(objectModel, event) {
        const primaryKey = this.selectedObjectModelTrigger.relatedModelPrimaryKeysArray.find(key => key.related_model_id === objectModel.id);
        primaryKey.primary_key = event.client_id;
      },
      showProcessModal() {
        this.showModal(this.vueModalID.configureObjectModelProcessFlow)
      },
      updateAppGroupVOptionSets(): void {
        this.notificationPermiteeOptions = this.objectModelTriggerNotificationVOptionSets.slice()
      },
    },
    computed: {
      application_id() {
        return this.selectedObjectModel.application_id
      },
      dynamicFieldsHandler(){
        return new ObjectModelPropertyDynamicFieldsHandler({mode: 'type',  objectModel: this.selectedObjectModel})
      },
      linkedForm: {
        get(): any {
          return {
            id: this.selectedObjectModelTrigger.linked_form_id,
            title: this.selectedObjectModelTrigger.linked_form_title,
          };
        },
        set(form: any) {
          this.selectedObjectModelTrigger.linked_form_id = form.id;
          this.selectedObjectModelTrigger.linked_form_title = form.title;
        }
      },
      linkedFormVSelectOptions: {
        get(): IVOptionSetEndpoint {
          return {
            valueKey: 'id',
            labelKey: 'title',
            rootKey: 'forms',
            endpoint: '/organizations/' + this.selectedObjectModel.organization_id + '/search_forms',
            endpointOptions: {
              per_page: 5,
              where: {
                application_id: this.selectedObjectModel.application_id
              }
            },
            selectedOption: this.linkedForm,
          };
        },
      },
      linkedObjectModels(): ObjectModel[] {
        if (this.selectedObjectModelTrigger.hasLinkedRelation) {
          if (!this.selectedObjectModelTrigger.linked_object_model_relation.root_object_model ||
            this.selectedObjectModelTrigger.linked_object_model_relation.rootObjectModel.id === this.selectedObjectModel.id) {
            return this.selectedObjectModelTrigger.linked_object_model_relation.related_object_models;
          }
          return [this.selectedObjectModelTrigger.linked_object_model_relation.rootObjectModel]
        } else {
          return [];
        }
      },
      updateableProperties() {
        return this.selectedObjectModel.objectModelPropertiesArray
          .filter(x => x.property_type !== ObjectModelPropertyRootType.DerivedField &&
            x.property_type !== ObjectModelPropertyRootType.AutoIncrement &&
            x.property_type !== ObjectModelPropertyRootType.RelationshipCount &&
            x.property_type !== ObjectModelPropertyRootType.MappedProperty)
      },
      linkedRelationshipSearchOptions(): IVOptionSetLocal {
        return {
          labelKey: (rel) => {
            if (rel.inverse) {
              return rel.label_title
            } else {
              return rel.inverse_label_title
            }
          },
          valueKey: "client_id_inverse",
          options: this.selectedObjectModel.allRelations,
        }
      },
      relationshipSearchOptions(): IVOptionSetLocal {
        return {
          labelKey: (rel) => {
            if (rel.inverse) {
              return rel.label_title
            } else {
              return rel.inverse_label_title
            }
          },
          valueKey: "client_id_inverse",
          options: this.selectedObjectModel.allRelations,
        }
      },
      foreignKeyOptions(): IVOptionSetLocal {
        return {
          labelKey: (prop) => {
            return prop.label_title
          },
          valueKey: "client_id",
          options: this.selectedObjectModel.objectModelPropertiesArray,
        }
      },
      linkedMapping: {
        get(): any {
          return {
            id: this.selectedObjectModelTrigger.mapping_id,
            title: this.selectedObjectModelTrigger.mapping_title,
          };
        },
        set(mapping: any) {
          this.selectedObjectModelTrigger.mapping_id = mapping.id;
          this.selectedObjectModelTrigger.mapping_title = mapping.title;
        }
      },
      orgMappingsOptions: {
        get(): IVOptionSetEndpoint {
          return {
            valueKey: 'id',
            labelKey: 'title',
            endpoint: `/object_models/${this.selectedObjectModel.id}/search_mappings`,
            endpointOptions: {
              where: {
                application_id: this.selectedObjectModel.application_id
              }
            },
            endpointFilters: {organization_id: this.selectedObjectModel.organization.id, per_page: 5},
            rootKey: 'mappings',
            selectedOption: this.linkedMapping
          };
        }
      },
      orgProcessFlowOptions: {
        get(): IVOptionSetEndpoint {
          return {
            valueKey: 'id',
            labelKey: 'title',
            endpoint: RouteHelper.path({ route: Route.objectModelSearchProcessFlows, modelOrId: this.selectedObjectModel.id }),
            endpointOptions: {
              where: {
                application_id: this.selectedObjectModel.application_id
              }
            },
            endpointFilters: {organization_id: this.selectedObjectModel.organization.id, per_page: 5, filters: {user_interactions_enabled: false}},
            rootKey: 'process_flows',
            selectedOption: this.selectedProcessFlow
          };
        }
      },
      selectedProcessFlow: {
        get(): IShallowProcessFlow {
          if (this.selectedObjectModelTrigger.process_flow_id) {
            return this.selectedObjectModelTrigger.process_flow;
          }
        },
        set(data: any): void {
          ProcessFlowSubmissionMappedVariable.destroyAll(this.selectedObjectModelTrigger);

          this.selectedObjectModelTrigger.process_flow = {
            id: data.id,
            title: data.title,
            is_published: data.is_published,
            variables: data.variables,
          };
          this.selectedObjectModelTrigger.process_flow_id = data.id;
        }
      },
      updatePropertyValueDateFormulaDynamicOptions(): IDynamicFieldsOptions[] {
        return [
          {
            is: 'dynamic-fields-tree',
            props: {
              objectModel: this.selectedObjectModel,
              fieldsHandler: new ObjectModelPropertyDynamicFieldsHandler({mode: 'flat', objectModel: this.selectedObjectModel}),
            },
          },
        ];
      },

    },

  });
</script>